import { Fragment } from 'react';

import { Button, Divider, Grid, Modal, Typography } from '@kc-console/common-ui';
import { useTranslation } from '@kc-console/core';

import type { ReactNode } from 'react';

interface Item {
  label: string;
  value: ReactNode;
}

interface Subsection {
  items: Item[];
  title: string;
  useBottomBorder?: boolean;
}

interface Section {
  subSections: Subsection[];
}

interface HoykeyModalData {
  sections: Section[];
  title: string;
}

interface HotkeyModalProps {
  data: HoykeyModalData;
  onClose: () => void;
  open: boolean;
}

const HotkeyModal = ({ onClose, open, data }: HotkeyModalProps) => {
  const { t } = useTranslation();
  const { title, sections } = data;
  return (
    <Modal
      open={open}
      onClose={onClose}
      size={'md'}
      slotProps={{
        header: {
          title,
        },
        body: {
          children: (
            <Grid
              container
              sx={{
                bgcolor: 'background.paper',
                padding: '16px 0 32px',
                flexDirection: 'column',
              }}
            >
              <Grid
                container
                sx={{
                  '> div + div': {
                    marginLeft: '32px',
                  },
                }}
              >
                {sections.map((section, index) => {
                  const { subSections } = section;
                  return (
                    <Grid
                      key={index}
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        flex: 1,
                      }}
                    >
                      {subSections.map(subSection => {
                        const { title, items, useBottomBorder = false } = subSection;
                        return (
                          <Fragment key={title}>
                            <Grid key={title}>
                              <Typography variant={'heading/bold/md'} color={'text/default'}>
                                {title}
                              </Typography>
                              <Grid
                                container
                                sx={{
                                  flexDirection: 'column',
                                  display: 'grid',
                                  gap: '16px',
                                }}
                              >
                                {items.map(item => {
                                  const { label, value } = item;
                                  return (
                                    <Grid
                                      container
                                      key={label}
                                      css={{ justifyContent: 'space-between' }}
                                    >
                                      <Typography
                                        variant={'label/regular/md'}
                                        color={'text/default'}
                                      >
                                        {label}
                                      </Typography>
                                      {value}
                                    </Grid>
                                  );
                                })}
                              </Grid>
                            </Grid>
                            {useBottomBorder && (
                              <Grid sx={{ margin: '20px 0' }}>
                                <Divider />
                              </Grid>
                            )}
                          </Fragment>
                        );
                      })}
                    </Grid>
                  );
                })}
              </Grid>
              <Grid
                container
                display={'flex'}
                justifyContent={'flex-end'}
                sx={{ marginTop: '8px' }}
              >
                <Button size={'lg'} variant={'primary'} onClick={onClose}>
                  <Typography variant={'body/normal/md'}>
                    {t('common:common.action.confirm')}
                  </Typography>
                </Button>
              </Grid>
            </Grid>
          ),
        },
      }}
    />
  );
};

export default HotkeyModal;
